import { render } from "./AboutContact.vue?vue&type=template&id=5b98fa2e&scoped=true"
import script from "./AboutContact.vue?vue&type=script&lang=js"
export * from "./AboutContact.vue?vue&type=script&lang=js"

import "./AboutContact.vue?vue&type=style&index=0&id=5b98fa2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b98fa2e"]])

export default __exports__